<template>
  <b-card>
    <b-row class="justify-content-between">
      <b-col class="pr-md-32 pr-md-120">
        <h4>Horizontal list groups</h4>

        <p class="hp-p1-body">
          Set the prop <code>horizontal</code> to <code>true</code> to change
          the layout of list group items from vertical to horizontal across all
          breakpoints. Alternatively, set <code>horizontal</code> to a
          responsive breakpoint (<code>sm</code>, <code>md</code>,
          <code>lg</code>
          or xl) to make a list group horizontal starting at that breakpoint's
          min-width. Currently horizontal list groups cannot be combined with
          <code>flush</code> list groups.
          <br /><br />
          <strong>ProTip:</strong> Want equal-width list group items when horizontal? Add the
          class <code>flex-fill</code> to each list group item.
        </p>
      </b-col>

      <b-col class="hp-flex-none w-auto">
        <b-button
          @click="codeClick()"
          variant="text"
          class="btn-icon-only show-code-btn"
        >
          <i
            class="ri-code-s-slash-line hp-text-color-black-80 hp-text-color-dark-30 lh-1"
            style="font-size: 16px"
          ></i>
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <div class="col-12 mt-16">
        <p class="hp-p1-body"><strong>Always horizontal:</strong></p>

        <b-list-group horizontal>
          <b-list-group-item>Cras justo odio</b-list-group-item>
          <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
          <b-list-group-item>Morbi leo risus</b-list-group-item>
        </b-list-group>

        <p class="hp-p1-body mt-24"><strong>Horizontal at breakpoint md and above:</strong></p>

        <b-list-group horizontal="md">
          <b-list-group-item>Cras justo odio</b-list-group-item>
          <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
          <b-list-group-item>Morbi leo risus</b-list-group-item>
        </b-list-group>
      </div>

      <div
        v-if="codeActive"
        class="col-12 mt-24 hljs-container"
        :class="{ active: codeActiveClass }"
      >
        <pre v-highlightjs>
          <code class="hljs html">
            {{ codeText }}
          </code>
        </pre>
      </div>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import code from "./code";

export default {
  data() {
    return {
      codeText: code.horizontal,
      codeActive: false,
      codeActiveClass: false,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BListGroup,
    BListGroupItem,
  },
  methods: {
    codeClick() {
      this.codeActive = !this.codeActive;

      setTimeout(() => {
        this.codeActiveClass = !this.codeActiveClass;
      }, 100);
    },
  },
};
</script>
